// 素材件数のピルバッジ。クリックで素材パネルを該当タブ + この商品の
// フィルタ付きで開く。0 件は非活性。
// スタイルは tags ページと共用 (CommonTable.css の .count-pill)。
// Amazon / マニュアル商品一覧ページで共用する。
export function renderMaterialPill(folder: 'shared' | 'personal', count: number, onOpen: () => void) {
  // 個人フォルダは素材パネルの個人タブと同じサブカラー
  const variant = folder === 'personal' ? ' count-pill--personal' : '';
  if (count <= 0) {
    return <span className="count-pill count-pill--zero">0</span>;
  }
  return (
    <button
      type="button"
      className={`count-pill${variant}`}
      onClick={(e) => {
        e.stopPropagation();
        onOpen();
      }}
    >
      {count.toLocaleString()}
    </button>
  );
}
